import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import ServiceDetailHero from '../components/ServiceDetailHero';
import ServiceDetailContent from '../components/ServiceDetailContent';
import ServiceDetailFeatures from '../components/ServiceDetailFeatures';
import ServiceDetailProcess from '../components/ServiceDetailProcess';
import ServiceDetailPricing from '../components/ServiceDetailPricing';
import CTASection from '../../home/components/CTASection';
import { useSEO } from '../../../utils/seo';

const BrandIdentityPage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useSEO({
    title: 'Marka Kimliği & Kurumsal Tasarım - Sigorta360 | Logo ve Kurumsal Kimlik',
    description: 'Sigorta acenteleri için profesyonel marka kimliği ve kurumsal tasarım hizmeti. Logo tasarımı, kurumsal evrak, sosyal medya şablonları, marka rehberi. 15.000₺\'den başlayan paketler.',
    keywords: 'sigorta logo tasarım, marka kimliği, kurumsal kimlik, sigorta tasarım, logo yapımı',
    canonical: `${siteUrl}/hizmetler/marka-kimligi`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Marka Kimliği & Kurumsal Tasarım',
      description: 'Profesyonel marka kimliği ve kurumsal tasarım hizmeti',
      provider: {
        '@type': 'Organization',
        name: 'Sigorta360',
        url: siteUrl
      },
      areaServed: {
        '@type': 'Country',
        name: 'Türkiye'
      },
      offers: {
        '@type': 'AggregateOffer',
        priceCurrency: 'TRY',
        lowPrice: '15000',
        highPrice: '30000',
        offerCount: '3'
      }
    }
  });

  const heroData = {
    category: 'Marka & Tasarım',
    title: 'Marka Kimliği & Kurumsal Tasarım',
    description: 'Güven veren, profesyonel kurumsal kimlik tasarımları ile markanızı öne çıkarıyoruz. Logo tasarımından matbaa ürünlerine, sosyal medya şablonlarından marka rehberine kadar eksiksiz marka kimliği çözümleri.',
    image: 'https://public.readdy.ai/ai/img_res/62129fb34e1ad07f254848e49fc433f1.jpg',
  };

  const contentData = {
    overview: 'Güçlü bir marka kimliği, sigorta sektöründe güven ve profesyonellik için olmazsa olmazdır. Sigorta360 olarak, markanızın değerlerini yansıtan, akılda kalıcı ve tutarlı marka kimlikleri tasarlıyoruz.',
    benefits: [
      {
        icon: 'ri-shield-check-line',
        title: 'Güven İnşası',
        description: 'Profesyonel marka kimliği ile müşterilerinizde güven ve itibar oluşturun.',
      },
      {
        icon: 'ri-eye-line',
        title: 'Akılda Kalıcılık',
        description: 'Özgün ve etkileyici tasarımlarla rakiplerinizden ayrılın, akılda kalın.',
      },
      {
        icon: 'ri-palette-line',
        title: 'Tutarlı İmaj',
        description: 'Tüm platformlarda tutarlı görsel kimlik ile marka bilinirliğinizi artırın.',
      },
      {
        icon: 'ri-star-line',
        title: 'Profesyonel Görünüm',
        description: 'Kaliteli tasarımlarla markanızın profesyonel imajını güçlendirin.',
      },
    ],
  };

  const featuresData = {
    title: 'Marka Kimliği Hizmetlerimiz',
    features: [
      {
        icon: 'ri-brush-line',
        title: 'Logo Tasarımı',
        description: 'Özgün logo konseptleri, 3-5 farklı tasarım alternatifi, sınırsız revizyon, tüm dosya formatları.',
      },
      {
        icon: 'ri-file-text-line',
        title: 'Kurumsal Kimlik',
        description: 'Kartvizit, antetli kağıt, zarf, dosya, klasör tasarımları. Matbaa baskı desteği.',
      },
      {
        icon: 'ri-palette-line',
        title: 'Renk & Tipografi',
        description: 'Marka renk paleti oluşturma, font seçimi, kullanım kuralları belirleme.',
      },
      {
        icon: 'ri-image-line',
        title: 'Sosyal Medya Şablonları',
        description: 'Instagram, Facebook, LinkedIn için özel tasarım şablonları, story ve post formatları.',
      },
      {
        icon: 'ri-book-open-line',
        title: 'Marka Rehberi',
        description: 'Detaylı kullanım kılavuzu, logo kullanım kuralları, renk kodları, tipografi rehberi.',
      },
      {
        icon: 'ri-printer-line',
        title: 'Matbaa Ürünleri',
        description: 'Broşür, katalog, afiş, banner tasarımları. Baskı koordinasyonu ve takibi.',
      },
    ],
  };

  const processData = {
    title: 'Marka Tasarım Sürecimiz',
    steps: [
      {
        number: '01',
        title: 'Keşif & Araştırma',
        description: 'Marka değerlerinizi anlama, hedef kitle analizi, rakip analizi, sektör trendleri incelemesi.',
      },
      {
        number: '02',
        title: 'Konsept Geliştirme',
        description: 'Mood board oluşturma, renk paleti belirleme, tipografi seçimi, ilk konsept çizimleri.',
      },
      {
        number: '03',
        title: 'Tasarım',
        description: 'Logo tasarımı, kurumsal kimlik ürünleri, sosyal medya şablonları, matbaa ürünleri.',
      },
      {
        number: '04',
        title: 'Revizyon & Onay',
        description: 'Geri bildirim alma, revizyonlar, final onayı, tüm dosyaların hazırlanması.',
      },
      {
        number: '05',
        title: 'Teslim & Destek',
        description: 'Tüm dosyaların teslimi, marka rehberi hazırlama, kullanım eğitimi, sürekli destek.',
      },
    ],
  };

  const pricingData = {
    title: 'Marka Kimliği Paketleri',
    packages: [
      {
        name: 'Başlangıç',
        price: '15.000',
        period: 'proje',
        description: 'Marka temellerinin oluşturulması',
        features: [
          'Profesyonel logo tasarımı',
          'Marka renk paleti oluşturma',
          'Tipografi seçimi ve rehberi',
          'Logo varyasyonları (renkli, siyah-beyaz)',
          'Temel kullanım kuralları',
          'Tüm dosya formatları (AI, PNG, SVG, PDF)',
          '3 Konsept alternatifi',
          'Sınırsız revizyon',
        ],
        highlighted: false,
      },
      {
        name: 'Profesyonel',
        price: '22.000',
        period: 'proje',
        description: 'Kurumsal malzemeler ve kullanım rehberi',
        features: [
          'Tam logo tasarım paketi',
          'Kurumsal evrak tasarımları (kartvizit, antetli, zarf)',
          'Dosya ve klasör tasarımları',
          'Detaylı marka kullanım rehberi',
          'Sosyal medya profil görselleri',
          'E-posta imza tasarımı',
          'Matbaa baskı koordinasyonu',
          '6 Ay tasarım desteği',
        ],
        highlighted: true,
      },
      {
        name: 'Premium',
        price: '30.000',
        period: 'proje',
        description: 'Tam kimlik sistematiği ve dijital set',
        features: [
          'Eksiksiz kurumsal kimlik paketi',
          'Sosyal medya içerik şablon kiti',
          'Broşür ve katalog tasarımları',
          'Araç giydirme tasarımları',
          'Tabela ve dış mekan uygulamaları',
          'Promosyon ürünleri tasarımı',
          'Kapsamlı marka rehberi kitapçığı',
          '12 Ay premium tasarım desteği',
        ],
        highlighted: false,
      },
    ],
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <ServiceDetailHero data={heroData} />
        <ServiceDetailContent data={contentData} />
        <ServiceDetailFeatures data={featuresData} />
        <ServiceDetailProcess data={processData} />
        <ServiceDetailPricing data={pricingData} />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default BrandIdentityPage;
